import { useState, useEffect, useRef, useMemo } from "react";
import { Box, DialogActions, DialogContent, Grid, IconButton, Button, Typography } from "@mui/material";
import { useFiles } from "../../../../hook/useFiles";
import TextInputComponent from "../../../atom/Inputs/TextInput";
import TextButtonComponet from "../../../atom/Buttons/TextButton";
import VideoDropDownComponent from "../../../atom/Inputs/VideoDropDown";
import { COURSE_SECTION_TYPE, COURSE_SECTION_TYPE_ID, getText, onToast } from "../../../../core/Constant";
import { Actions } from "../../../../core/modules/Actions";
import { connect, useDispatch } from 'react-redux';
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import DropDownComponent from "../../../atom/Inputs/DropDown";
import TableComponent from "../../../atom/Table/TableComponent";
import WeekDropdown from "../../../atom/Inputs/WeekDropdown";
import DeleteIcon from "@mui/icons-material/Delete";
import SectionTypeIcon from "../../../atom/Icons/SectionTypeIcon";
import DocumentIcon from "../../../atom/Icons/DocumentIcon";
import SelectDocumentModal from "./SelectDocumentModal";
import SelectQuizModal from "./SelectQuizModal";


const AdminCourseWeekContent = ({ open, onClose, courseID, weekNo, dayNo, fetchVideo, uploadedVideoList, dataState, sectionName, courseQuizList, getCourseQuizList, documentList, getDocumentList }) => {
    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState(1);

    const [title, setTitle] = useState('');
    const [titleError, setTitleError] = useState(false);
    const [titleErrorMsg, setTitleErrorMsg] = useState('Please add the title');
    const [titalValid, setTitleVaid] = useState(false);

    const [link, setLink] = useState('');
    const [linkError, setLinkError] = useState(false);
    const [linkErrorMsg, setLinkErrorMsg] = useState('');
    const [isLinkValid, setIsLinkVaid] = useState(false);

    const [duration, setDuration] = useState('');
    const [durationError, setDurationError] = useState(false);
    const [durationErrorMsg, setDurationErrorMsg] = useState('Please add the valid duration');
    const [isDurationValid, setDurationValid] = useState(false);

    const [newWeekContent, setNewWeekContent] = useState([]);
    const [uploadedVideos, setUploadedVideos] = useState([]);
    const [contentDayCount, setContentDayCount] = useState(0);
    const [saveBtnValidMsg, setSaveBtnValidMsg] = useState('');

    const [type, setType] = useState(COURSE_SECTION_TYPE[0]?.id);
    const [isTypeError, setTypeError] = useState(false);
    const [isTypeValid, setTypeValid] = useState(true);


    const [quizs, setQuizs] = useState([])

    const videoList = useMemo(() =>
        (Array.isArray(uploadedVideoList?.data)) ? uploadedVideoList.data : []
        , [uploadedVideoList]);

    const filesOnly = useFiles(documentList);
    const [selectedDocName, setSelectedDocName] = useState("");
    const [selectedDocFolderStack, setSelectedDocFolderStack] = useState([]);
    const [openSelectModal, setOpenSelectModal] = useState(false);

    const handleDocumentSelect = (doc, parentId, folderStack) => {
        setLink(doc.id);
        setSelectedDocName(doc.name);
        setSelectedDocFolderStack(folderStack);
        const cleanName = doc.name ? doc.name.replace(/\.[^/.]+$/, "") : "";
        setTitle(cleanName);
        if (cleanName.length > 255) {
            setTitleError(true);
            setTitleErrorMsg("Maximum 255 characters allowed.");
            setTitleVaid(false);
        } else {
            setTitleError(false);
            setTitleErrorMsg("Please add the title");
            setTitleVaid(cleanName.length > 0);
        }
        setLinkError(false);
        setIsLinkVaid(doc.id > 0);
        setOpenSelectModal(false);
    };

    const [selectedQuizName, setSelectedQuizName] = useState("");
    const [selectedQuizFolderStack, setSelectedQuizFolderStack] = useState([]);
    const [openQuizSelectModal, setOpenQuizSelectModal] = useState(false);

    const handleQuizSelect = (quiz, parentId, folderStack) => {
        setLink(quiz.id);
        setSelectedQuizName(quiz.name);
        setSelectedQuizFolderStack(folderStack);
        const cleanName = quiz.name ? quiz.name : "";
        setTitle(cleanName);
        if (cleanName.length > 255) {
            setTitleError(true);
            setTitleErrorMsg("Maximum 255 characters allowed.");
            setTitleVaid(false);
        } else {
            setTitleError(false);
            setTitleErrorMsg("Please add the title");
            setTitleVaid(cleanName.length > 0);
        }
        setLinkError(false);
        setIsLinkVaid(quiz.id > 0);
        setOpenQuizSelectModal(false);
    };



    const [day, setDay] = useState('');
    const [dayError, setDayError] = useState(false);
    const [isDayValid, setDayValid] = useState(false);

    const [newSectionName, setSectionName] = useState('');
    const [sectionNameError, setSectionNameError] = useState(false);
    const [sectionNameErrorMsg, setSectionNameErrorMsg] = useState('Please add the section name');
    const [isSectionNameValid, setSectionNameValid] = useState(false);
    const [sectionNameRead, setSectionNameReadOnly] = useState(false);


    useEffect(() => {
        setContentDayCount(dayNo)
        if (dataState === 0) {
            resetInput();
            setSectionName("");
            setSectionNameValid(false);
            setSectionNameError(false);
            setSectionNameErrorMsg('Please add the section name');
            setSectionNameReadOnly(false)

        } else {
            const secName = sectionName || "";
            setSectionName(secName);
            if (secName.length > 255) {
                setSectionNameValid(false);
                setSectionNameError(true);
                setSectionNameErrorMsg("Maximum 255 characters allowed.");
            } else {
                setSectionNameValid(secName.trim().length > 0);
                setSectionNameError(false);
                setSectionNameErrorMsg('Please add the section name');
            }
        }

    }, [dayNo, dataState, sectionName]);

    useEffect(() => {
        if (!open) {
            resetInput();
            setNewWeekContent([])
            setSaveBtnValidMsg('');
            setSectionName("");
            setSectionNameError(false);
            setSectionNameErrorMsg('Please add the section name');
            setSectionNameValid(false);
            setSectionNameReadOnly(false);
        }
    }, [open]);

    useEffect(() => {
        // get quiz and document list by course
        getCourseQuizList(courseID);
        if (getDocumentList) {
            getDocumentList(courseID);
        }
    }, [courseID]);

    useEffect(() => {
        setQuizs(courseQuizList);
    }, [courseQuizList])

    useEffect(() => {
        setNewWeekContent(newWeekContent)

    }, [newWeekContent]);


    const onAddValues = () => {
        setNewWeekContent([
            ...newWeekContent,
            {
                "content_type": (type === COURSE_SECTION_TYPE_ID.QUIZ || type === COURSE_SECTION_TYPE_ID.DOCUMENT) && dataState === 0 ? String(type) : String(COURSE_SECTION_TYPE_ID.VIDEO),
                'content': title,
                'link': String(link),
                'duration': (type === COURSE_SECTION_TYPE_ID.DOCUMENT && dataState === 0) ? null : duration,
                'day': day && day !== '' ? day : 0,
                'is_locked': '1',
            }
        ]);

        setContentDayCount(contentDayCount + 1)
        resetInput();
        setSectionNameValid(true);
        setSectionNameError(false);
        setSectionNameReadOnly(true);
    }

    const onAddVideoContentToDo = () => {
        if (isLinkValid && isDurationValid && titalValid && isDayValid && isSectionNameValid) {

            onAddValues();

        } else {
            if (!isLinkValid) {
                setLinkError(true);
            }
            if (!isDurationValid) {
                setDurationError(true);
            }
            if (!titalValid) {
                setTitleError(true);
                if (title && title.length > 255) {
                    setTitleErrorMsg("Maximum 255 characters allowed.");
                } else {
                    setTitleErrorMsg("Please add the title");
                }
            }
            if (!isDayValid) {
                setDayError(true);
            }

            if (!isSectionNameValid) {
                setSectionNameError(true);
                if (newSectionName && newSectionName.length > 255) {
                    setSectionNameErrorMsg("Maximum 255 characters allowed.");
                } else {
                    setSectionNameErrorMsg("Please add the section name");
                }
            }
        }

    }

    const onAddQuizToDo = () => {
        const isLnkValid = link !== undefined && link !== "" && link !== 0 && link !== "0";
        setIsLinkVaid(isLnkValid);
        setLinkError(!isLnkValid);

        const isDurValid = type === COURSE_SECTION_TYPE_ID.DOCUMENT ? true : isDurationValid;

        if (isLnkValid && isDurValid && titalValid && isDayValid && isSectionNameValid) {
            onAddValues();
        } else {
            if (!isLnkValid) {
                setLinkError(true);
            }
            if (!isDurValid) {
                setDurationError(true);
            }
            if (!titalValid) {
                setTitleError(true);
                if (title && title.length > 255) {
                    setTitleErrorMsg("Maximum 255 characters allowed.");
                } else {
                    setTitleErrorMsg("Please add the title");
                }
            }
            if (!isDayValid) {
                setDayError(true);
            }
            if (!isSectionNameValid) {
                setSectionNameError(true);
                if (newSectionName && newSectionName.length > 255) {
                    setSectionNameErrorMsg("Maximum 255 characters allowed.");
                } else {
                    setSectionNameErrorMsg("Please add the section name");
                }
            }
        }
    }

    const addToList = () => {
        setSaveBtnValidMsg('');

        if (dataState === 1 || (dataState === 0 && type === COURSE_SECTION_TYPE_ID.VIDEO)) {
            onAddVideoContentToDo()
        } else {
            onAddQuizToDo()
        }


    };

    const removeFromList = (index) => {
        const updatedList = newWeekContent.filter((_, i) => i !== index);
        setNewWeekContent(updatedList);
    };

    const columns = useMemo(() => [
        {
            name: "day",
            label: "Day",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => `Day ${value}`,
            },
        },
        {
            name: "content_type",
            label: "Type",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => {
                    const rowIndex = tableMeta.rowIndex;
                    const item = newWeekContent[rowIndex];
                    const typeId = Number(value);

                    const doc = filesOnly.find((d) => String(d.id) === String(item?.link));
                    const docName = doc ? doc.name : item?.link;
                    const typeName = COURSE_SECTION_TYPE.find(c => c.id === typeId).name;

                    return (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <SectionTypeIcon sx={{ marginRight: 5 }} contentType={value} fileName={docName} />
                            <span>{typeName}</span>
                        </Box>
                    );
                },
            },
        },
        {
            name: "content",
            label: "Title",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => value,
            },
        },
        {
            name: "link",
            label: "Link",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => {
                    const rowIndex = tableMeta.rowIndex;
                    const item = newWeekContent[rowIndex];
                    if (String(item?.content_type) === String(COURSE_SECTION_TYPE_ID.VIDEO)) {
                        // Video
                        const video = uploadedVideos.find((v) => String(v.link) === String(value));
                        return video ? video.title : value;
                    } else if (String(item?.content_type) === String(COURSE_SECTION_TYPE_ID.DOCUMENT)) {
                        // Document
                        const docItem = filesOnly.find((d) => String(d.id) === String(value));
                        return docItem ? docItem.name : value;
                    } else {
                        // Quiz
                        const quizItem = quizs.find((q) => String(q.id) === String(value));
                        return quizItem ? quizItem.name : value;
                    }
                },
            },
        },
        {
            name: "duration",
            label: "Duration (Min)",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value) => value,
            },
        },
        {
            name: "action",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (value, tableMeta) => {
                    const rowIndex = tableMeta.rowIndex;
                    return (
                        <IconButton onClick={() => removeFromList(rowIndex)}>
                            <DeleteIcon style={{ color: "#9E9E9E" }} />
                        </IconButton>
                    );
                },
            },
        },
    ], [uploadedVideos, quizs, newWeekContent, filesOnly]);

    useEffect(() => {
        setSaveBtnValidMsg('');
    }, []);

    useEffect(() => {
        setUploadedVideos(videoList);

    }, [videoList]);

    const onTitleChange = (e) => {
        const text = getText(e);
        setTitle(text);
        if (text && text.length > 255) {
            setTitleError(true);
            setTitleErrorMsg("Maximum 255 characters allowed.");
            setTitleVaid(false);
        } else {
            setTitleError(false);
            setTitleErrorMsg("Please add the title");
            const isValid = text?.trim().length > 0;
            setTitleVaid(isValid);
        }
    }

    const onLinkChange = (e, videoItem) => {
        const text = e?.target?.value !== undefined ? e.target.value : (typeof e === 'string' ? e : e?.link || "");
        setLink(text);
        setLinkError(false);
        const isValid = text !== undefined && text !== null && String(text).length > 0;
        setIsLinkVaid(isValid);

        if (videoItem) {
            const videoTitle = videoItem.title || videoItem.name || "";
            if (videoTitle && (!title || title.trim() === "")) {
                const cleanTitle = videoTitle.replace(/\.[^/.]+$/, "");
                setTitle(cleanTitle);
                if (cleanTitle.length > 255) {
                    setTitleError(true);
                    setTitleErrorMsg("Maximum 255 characters allowed.");
                    setTitleVaid(false);
                } else {
                    setTitleError(false);
                    setTitleErrorMsg("Please add the title");
                    setTitleVaid(cleanTitle.length > 0);
                }
            }
            if (videoItem.duration && (!duration || duration === "")) {
                setDuration(String(videoItem.duration));
                setDurationError(false);
                setDurationValid(true);
            }
            setUploadedVideos(prev => {
                if (prev.some(v => String(v.link) === String(videoItem.link))) return prev;
                return [...prev, videoItem];
            });
        }
    }

    const onDurationChange = (e) => {
        const rawText = getText(e) || "";
        const cleanText = rawText.replace(/[^0-9]/g, "");
        setDuration(cleanText);
        setDurationError(false);
        const isValid = cleanText.length > 0 && Number(cleanText) > 0;
        setDurationValid(isValid);
    }

    const onDayChange = (e) => {
        const text = getText(e)
        setDay(text);
        setDayError(false)
        const isValid = text !== undefined && text !== "";
        setDayValid(isValid);
    }

    const onSectionTypeChange = (e) => {
        const text = getText(e);
        setType(text);
        setTypeError(false);
        setTypeValid(true);
        setLink("");
        setSelectedDocName("");
        setSelectedDocFolderStack([]);
        setSelectedQuizName("");
        setSelectedQuizFolderStack([]);
        setLinkError(false);
        setIsLinkVaid(false);
    }

    const onNewSectionChange = (e) => {
        const text = getText(e);
        setSectionName(text);
        if (text && text.length > 255) {
            setSectionNameError(true);
            setSectionNameErrorMsg("Maximum 255 characters allowed.");
            setSectionNameValid(false);
        } else {
            setSectionNameError(false);
            setSectionNameErrorMsg("Please add the section name");
            const isValid = text?.trim().length > 0;
            setSectionNameValid(isValid);
        }
    }

    const resetInput = () => {
        setTitle("");
        setLink("");
        setDuration("");
        setDay("");
        setSelectedDocName("");
        setSelectedDocFolderStack([]);
        setOpenSelectModal(false);
        setSelectedQuizName("");
        setSelectedQuizFolderStack([]);
        setOpenQuizSelectModal(false);

        setTitleVaid(false);
        setIsLinkVaid(false);
        setDurationValid(false);
        setDayValid(false);

        setLinkError(false);
        setDurationError(false);
        setTitleError(false);
        setTitleErrorMsg("Please add the title");
        setDayError(false);
    }

    const saveAddedWeekContent = () => {

        if (newWeekContent.length > 0) {

            var json_request_data = '{"course_id": "' + courseID + '","weeks": [ {"week": "' + newSectionName + '","details": ' + JSON.stringify(newWeekContent) + '}]}';
            dispatch(Actions.course.createCourseContent(JSON.parse(json_request_data)))
            onClose();


        } else {

            setSaveBtnValidMsg('Please add at least one day course content');


        }
    }

    return (
        <>
            <form>
                <DialogContent>
                    <Grid container>
                        {dataState === 0 && (<>
                            <Grid item xs={12} md={5}>
                                <TextInputComponent
                                    label={"Section Name"}
                                    isError={sectionNameError}
                                    placeholder="Enter section name"
                                    name={"newSectionName"}
                                    value={newSectionName}
                                    error={sectionNameErrorMsg}
                                    onchange={onNewSectionChange}
                                    readOnly={sectionNameRead}
                                />
                            </Grid>
                            <Grid item xs={12} md={5}>
                                <Box>
                                    <DropDownComponent
                                        isShowZero={false}
                                        isError={isTypeError}
                                        error={'Please select a type'}
                                        readOnly={false}
                                        selectedValue={type}
                                        name="sectionType"
                                        initialValue=""
                                        list={COURSE_SECTION_TYPE}
                                        dropdownLabel="Section Type"
                                        onchange={onSectionTypeChange}
                                        fixedWidth="100%"
                                    />
                                </Box>
                            </Grid>
                        </>)}

                        <Grid item xs={12} md={2}>
                            <Box>
                                <WeekDropdown
                                    selectedValue={day}
                                    onchange={onDayChange}
                                    isError={dayError}
                                    error="Please select a day"
                                    readOnly={false}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            {dataState === 1 || (dataState === 0 && type === COURSE_SECTION_TYPE_ID.VIDEO) ?
                                <Box>
                                    <VideoDropDownComponent
                                        placeholder="Search or select a video"
                                        onchange={onLinkChange}
                                        list={videoList}
                                        selectedValue={link}
                                        dropdownLabel="Video"
                                        isError={linkError}
                                        error="Select a video" />
                                    {linkError ? <p className="input-error-text">Select a video </p> : null}
                                </Box>
                                : type === COURSE_SECTION_TYPE_ID.QUIZ ?
                                    <Box style={{ padding: 10 }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "100%",
                                            }}
                                        >
                                            <p
                                                style={{
                                                    padding: 0,
                                                    margin: 0,
                                                    marginBottom: 10,
                                                    color: "#4E657C",
                                                    fontSize: 19,
                                                    fontWeight: 700,
                                                }}
                                            >
                                                Quiz
                                            </p>
                                            <Box
                                                onClick={() => setOpenQuizSelectModal(true)}
                                                className="form-control"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    borderRadius: "8px",
                                                    border: linkError ? "1.5px solid #d32f2f" : "1.5px solid #CCCCCC",
                                                    cursor: "pointer",
                                                    backgroundColor: "#FFFFFF",
                                                }}
                                            >
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, overflow: "hidden" }}>
                                                    {link ? (
                                                        <Typography
                                                            sx={{
                                                                fontSize: "14px",
                                                                color: "#495057",
                                                                fontWeight: 400,
                                                                fontFamily: "Montserrat",
                                                                overflow: "hidden",
                                                                whiteSpace: "nowrap",
                                                                mr: 1
                                                            }}
                                                        >
                                                            {selectedQuizName}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            sx={{
                                                                fontSize: "14px",
                                                                color: "#8C8C8C",
                                                                fontFamily: "Montserrat",
                                                            }}
                                                        >
                                                            Select Quiz
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Button
                                                    variant="text"
                                                    sx={{
                                                        textTransform: "none",
                                                        color: "#9834F0",
                                                        fontWeight: 600,
                                                        fontFamily: "Montserrat",
                                                        padding: 0,
                                                        minWidth: "auto",
                                                        fontSize: "14px",
                                                        "&:hover": { backgroundColor: "transparent" },
                                                    }}
                                                >
                                                    {link ? "Change" : "Browse"}
                                                </Button>
                                            </Box>
                                            {linkError && (
                                                <Typography
                                                    sx={{
                                                        color: "#d32f2f",
                                                        fontSize: "12px",
                                                        fontFamily: "Montserrat",
                                                        marginLeft: "14px",
                                                        marginTop: "4px",
                                                    }}
                                                >
                                                    Please select a quiz
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                    :
                                    <Box style={{ padding: 10 }}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                width: "100%",
                                            }}
                                        >
                                            <p
                                                style={{
                                                    padding: 0,
                                                    margin: 0,
                                                    marginBottom: 10,
                                                    color: "#4E657C",
                                                    fontSize: 19,
                                                    fontWeight: 700,
                                                }}
                                            >
                                                Document
                                            </p>
                                            <Box
                                                onClick={() => setOpenSelectModal(true)}
                                                className="form-control"
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    borderRadius: "8px",
                                                    border: linkError ? "1.5px solid #d32f2f" : "1.5px solid #CCCCCC",
                                                    cursor: "pointer",
                                                    backgroundColor: "#FFFFFF",
                                                }}
                                            >
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, overflow: "hidden" }}>
                                                    {link ? (
                                                        <>
                                                            <DocumentIcon fileName={selectedDocName} />
                                                            <Typography
                                                                sx={{
                                                                    fontSize: "14px",
                                                                    color: "#495057",
                                                                    fontWeight: 400,
                                                                    fontFamily: "Montserrat",
                                                                    overflow: "hidden",
                                                                    whiteSpace: "nowrap",
                                                                    mr: 1
                                                                }}
                                                            >
                                                                {selectedDocName}
                                                            </Typography>
                                                        </>
                                                    ) : (
                                                        <Typography
                                                            sx={{
                                                                fontSize: "14px",
                                                                color: "#8C8C8C",
                                                                fontFamily: "Montserrat",
                                                            }}
                                                        >
                                                            Select Document
                                                        </Typography>
                                                    )}
                                                </Box>
                                                <Button
                                                    variant="text"
                                                    sx={{
                                                        textTransform: "none",
                                                        color: "#9834F0",
                                                        fontWeight: 600,
                                                        fontFamily: "Montserrat",
                                                        padding: 0,
                                                        minWidth: "auto",
                                                        fontSize: "14px",
                                                        "&:hover": { backgroundColor: "transparent" },
                                                    }}
                                                >
                                                    {link ? "Change" : "Browse"}
                                                </Button>
                                            </Box>
                                            {linkError && (
                                                <Typography
                                                    sx={{
                                                        color: "#d32f2f",
                                                        fontSize: "12px",
                                                        fontFamily: "Montserrat",
                                                        marginLeft: "14px",
                                                        marginTop: "4px",
                                                    }}
                                                >
                                                    Please select a document
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                            }
                        </Grid>


                        <Grid item xs={12} md={5}>
                            <Box>
                                <TextInputComponent
                                    label={"Title"}
                                    isError={titleError}
                                    placeholder="Enter Title"
                                    name={"title"}
                                    value={title}
                                    error={titleErrorMsg}
                                    onchange={onTitleChange}
                                />
                            </Box>
                        </Grid>
                        {type != COURSE_SECTION_TYPE_ID.DOCUMENT && (
                            <Grid item xs={12} md={2}>
                                <Box>
                                    <TextInputComponent
                                        label={"Duration (MIN)"}
                                        isError={durationError}
                                        placeholder="Duration (MIN)"
                                        name={"duration"}
                                        value={duration}
                                        error={durationErrorMsg}
                                        type="text"
                                        onchange={onDurationChange}
                                    />
                                </Box>
                            </Grid>
                        )}
                        <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", mt: 2, pb: 1 }}>
                            <TextButtonComponet text={"Add"} style={{ width: "80px" }} onButtonClick={() => addToList()} />
                        </Grid>
                    </Grid>

                    <Grid container xs={12}>
                        {newWeekContent.length > 0 ? (
                            <>
                                <Grid item xs={12} container direction={'row'} justifyContent="center" alignItems="center" mb={2} >
                                    <Box mt={1} >
                                        <HeadingComponent text={"Added Content"} fontweigth={600} size={25} fontfamily={"Montserrat"} />
                                    </Box>
                                </Grid>
                                <Grid item xs={12}>
                                    <Box sx={{ border: "1px solid #E0E0E0", borderRadius: "10px", overflow: "hidden" }}>
                                        <TableComponent
                                            columns={columns}
                                            data={newWeekContent}
                                            filter={false}
                                            search={false}
                                            download={false}
                                            selectableRowsHideCheckboxes={true}
                                            elevation={0}
                                            pagination={false}
                                        />
                                    </Box>
                                </Grid>
                            </>
                        ) : null}
                        <Box>
                            <b> <p className="text-center" style={{ color: 'red' }}>{saveBtnValidMsg}</p></b>
                        </Box>
                    </Grid>

                </DialogContent>
                <DialogActions sx={{ mr: 2, mb: 2 }}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <TextButtonComponet text={"Cancel"} classStyle="btn btn-secondary" width={120} onButtonClick={() => onClose()} />
                        <TextButtonComponet text={"Save"} width={120} onButtonClick={() => saveAddedWeekContent()} />
                    </Box>

                </DialogActions>
            </form>
            <SelectDocumentModal
                open={openSelectModal}
                onClose={() => setOpenSelectModal(false)}
                courseID={courseID}
                onSelect={handleDocumentSelect}
                initialFolderStack={selectedDocFolderStack}
                selectedDocId={link}
            />
            <SelectQuizModal
                open={openQuizSelectModal}
                onClose={() => setOpenQuizSelectModal(false)}
                courseID={courseID}
                onSelect={handleQuizSelect}
                initialFolderStack={selectedQuizFolderStack}
                selectedQuizId={link}
            />
        </>
    );
}

export default connect(
    state => ({
        uploadedVideoList: state.video.get("uploadedVideoList"),
        loadingAction: state.common.get("loadingAction"),
        courseQuizList: state.course.get("courseQuizList"),
        documentList: state.course.get("courseDocumentList"),
    }),
    {
        fetchVideo: Actions.video.fetchVideo,
        getCourseQuizList: Actions.course.getCourseQuizList,
        getDocumentList: Actions.course.getCourseDocumentList
    }
)(AdminCourseWeekContent);
